// OAuth認可画面 /oauthAuthorize
import React, { Component } from 'react';
import { Link } from 'react-router';
import Header from './header'
import Footer from './footer'
import './css/oauthAuthorize.css';
import { browserHistory } from 'react-router';
import { getServiceName, getIconUrl } from './firebase'

export default class oauthAuthorize extends Component {
  constructor(props) {
    super(props);
    this.state = {
      iconUrl: '',
      serviceName: '',
      query: {},
    }
  }

  componentWillMount = async () => {
    const query = this.props.location.query;
    if (!query.client_id || !query.redirect_uri) {
      // 必須クエリが含まれてない
      browserHistory.push('/');
    }
    this.setState({ query });
    try {
      const serviceName = await getServiceName(query.client_id);
      this.setState({ serviceName });
      const iconUrl = await getIconUrl(query.client_id);
      this.setState({ iconUrl });
    } catch (err) {
      browserHistory.push('/')
    }
  }

  handleMyRateLogin = () => {
    browserHistory.push({
      pathname: '/oauthLogin',
      state:{
        clientId: this.state.query.client_id,
        redirectUri: this.state.query.redirect_uri,
      }
    })
  }

  render() {
    return (
    <div id="wrapper">
      <div id="" className="wrapper-lp wrapper-login">
        <Header isOauth={true} />
        <div className="webWrap">
          <div className="wrapCover">
            <div className="wrapCover__contentBlock clearfix">
              <div className="content-top">
                <div className="block-login">
                  <h2 className="subtitle-en">MyRate Login</h2>
                  <div className="block-icon">
                    <img className="icon-img" src={this.state.iconUrl} alt=''></img>
                  </div>
                  <div className="block-connect-statement">
                    <p className="connect-statement">{`”${this.state.serviceName}”と連携`}</p>
                  </div>
                  <div className="block-auth-statement">
                    <p className="auth-statement">MyRateアカウントの利用を許可する場合はログインに進んでください。</p>
                    <p className="auth-statement">連携される情報：ログインID</p>
                  </div>
                  <div className="">
                    <form className="form-login">
                      <button className="submit" type="button" onClick={this.handleMyRateLogin}>許可してログインする</button>
                    </form>
                  </div>
                  <Link to='/newflow1' className="acccount-register-link">MyRateアカウントを作成する</Link>
                </div>
              </div>

            </div>
            <Footer/>
          </div>
        </div>
      </div>
    </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/oauthAuthorize.js